import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { api } from 'services/api';
import { Guide } from 'types/guide';

export function useFetchGuide(id: string | undefined) {
  const [guide, setGuide] = useState<Guide | null>(null);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    async function fetchGuide() {
      if (!id) return;
      setLoading(true);
      try {
        await api.get<Guide>(`/guides/${id}`).then(response => {
          setGuide(response.data);
        });
      } catch (err) {
        toast.error('Erro ao buscar guia para impressão');
      } finally {
        setLoading(false);
      }
    }
    fetchGuide();
  }, [id]);

  return { guide, loading };
}
